import React, { useMemo } from 'react';
import { computeAttentionItems } from '../utils/computeAttentionItems';

const KIND_DOT = {
    submitted: 'bg-teal-500',
    disputed: 'bg-amber-500',
    escrow: 'bg-zinc-400',
    inactive: 'bg-zinc-400',
};

const MAX_VISIBLE = 5;

const NeedsAttentionPanel = ({
    companyTasks = [],
    employees = [],
    onOpenTask,
    onViewTasks,
}) => {
    const items = useMemo(
        () => computeAttentionItems(companyTasks, employees),
        [companyTasks, employees],
    );

    const visible = items.slice(0, MAX_VISIBLE);
    const overflow = items.length - visible.length;

    return (
        <div className="rounded-2xl border border-zinc-200 bg-white p-5 shadow-sm dark:border-zinc-800 dark:bg-zinc-950/50">
            <div className="flex items-center justify-between gap-2">
                <h3 className="text-sm font-semibold text-zinc-900 dark:text-white">
                    Needs your attention
                </h3>
                {items.length > 0 && onViewTasks ? (
                    <button
                        type="button"
                        onClick={onViewTasks}
                        className="text-xs font-medium text-teal-700 hover:text-teal-800 dark:text-teal-400"
                    >
                        All tasks
                    </button>
                ) : null}
            </div>

            {items.length === 0 ? (
                <p className="mt-3 text-sm text-zinc-500 dark:text-zinc-400">
                    Nothing blocking payroll right now.
                </p>
            ) : (
                <ul className="mt-3 divide-y divide-zinc-100 dark:divide-zinc-800/80">
                    {visible.map((item) => (
                        <li key={item.id}>
                            <button
                                type="button"
                                onClick={() => onOpenTask?.(item.task)}
                                className="flex w-full items-start gap-3 py-2.5 text-left transition hover:bg-zinc-50/80 dark:hover:bg-zinc-900/40 rounded-lg px-1 -mx-1"
                            >
                                <span
                                    className={`mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full ${KIND_DOT[item.kind] || 'bg-zinc-400'}`}
                                    aria-hidden
                                />
                                <span className="min-w-0 flex-1">
                                    <span className="block truncate text-sm text-zinc-900 dark:text-zinc-100">
                                        {item.title}
                                    </span>
                                    <span className="mt-0.5 block text-xs text-zinc-500 dark:text-zinc-500">
                                        {item.hint}
                                    </span>
                                </span>
                                <i className="fa-solid fa-chevron-right mt-1 shrink-0 text-[10px] text-zinc-400" />
                            </button>
                        </li>
                    ))}
                </ul>
            )}

            {overflow > 0 ? (
                <p className="mt-2 text-xs text-zinc-500 dark:text-zinc-500">
                    +{overflow} more — open task list to review
                </p>
            ) : null}
        </div>
    );
};

export default NeedsAttentionPanel;
